import { connect } from "react-redux";

import Button from "@components/Button";
import { addModal } from "@store/app/actions";
import LicensePlate from "@components/Rca/LicensePlate";
import Heading from "@components/Heading";
import RCASavedInfoModal from "@containers/RCA/RCASavedInfo/RCASavedInfoModal";
import ModalErrorBoundary from "@containers/ModalErrorBoundary";
import { makeApiCall } from "@lib/api/helpers";
import { getRcaVehicleDetailsbyIdApi } from "@lib/api";

const RCASavedInfo = ({
  addModal,
  onStepChange,
  openedModal,
  onApiDataUpdate,
  apiData,
  onLoadingStateChange,
  isLoading,
}) => {
  const fetchVehicleDetails = async (vehicleId) => {
    const response = await makeApiCall({
      apiCall: getRcaVehicleDetailsbyIdApi,
      apiArgs: [vehicleId],
      formatResponse: (response) => response.data.data,
    });

    if (response) {
      onApiDataUpdate({
        savedVehicles: {
          ...apiData.savedVehicles,
          [vehicleId]: { ...response, fullDetailsFetched: true },
        },
      });
    }
  };

  const handleOpenModal = async (vehicleId) => {
    addModal(`${vehicleId}`);

    if (!apiData.savedVehicles?.[vehicleId]?.fullDetailsFetched) {
      if (!isLoading) {
        onLoadingStateChange(true);
      }
      await fetchVehicleDetails(vehicleId);

      onLoadingStateChange(false);
    }
  };

  const handleNextStep = async (vehicleId) => {
    if (!apiData.savedVehicles?.[vehicleId]?.fullDetailsFetched) {
      if (!isLoading) {
        onLoadingStateChange(true);
      }

      await fetchVehicleDetails(vehicleId);
      onLoadingStateChange(false);
    }

    onApiDataUpdate({
      selectedVehicle: vehicleId,
    });
    onStepChange(2);
  };

  const handleNewPolicyData = () => {
    onApiDataUpdate({ selectedVehicle: null });
    onStepChange(2);
  };

  return (
    <div className="space-y-[20px]">
      <Heading
        as="h4"
        title="Date pentru polita"
        display="h2"
        sameSizeOnMobile
      />

      <div className="text-sm font-medium">
        Alege dintre datele deja salvate sau adauga date noi.
      </div>

      <Button
        type="button"
        title="Adauga date noi"
        onClick={() => handleNewPolicyData()}
      />

      <div className="space-y-4">
        {Object.values(apiData.savedVehicles).map((vehicle) => (
          <div
            key={vehicle.id}
            className="bg-white p-[16px] flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-[28px] sm:space-y-0"
          >
            <div className="space-y-[10px]">
              <LicensePlate plateNumber={vehicle.plateNo} />

              <div className="font-medium">
                {vehicle.vehicleName ||
                  `${vehicle.brand || ""} ${vehicle.model || ""}`}
              </div>
            </div>

            {/* Buttons - stacked on mobile, inline on desktop */}
            <div className="flex flex-col sm:flex-row sm:items-center text-center gap-[20px]">
              <Button
                type="button"
                onClick={() => handleNextStep(vehicle.id)}
                title="Foloseste"
              />

              <button
                type="button"
                onClick={() => handleOpenModal(vehicle.id)}
                className="w-full sm:w-auto text-red-brand hover:text-bleu-hover underline text-center sm:text-left"
              >
                Vezi detalii
              </button>
            </div>

            {openedModal === `${vehicle.id}` && (
              <ModalErrorBoundary>
                <RCASavedInfoModal
                  isLoading={isLoading}
                  vehicleDetails={apiData.savedVehicles?.[vehicle.id]}
                />
              </ModalErrorBoundary>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default connect((state) => ({ openedModal: state.app.modal }), {
  addModal,
})(RCASavedInfo);
